module.exports = __webpack_public_path__ + "static/media/FIRSLogo.3946d689.svg";